import { render, staticRenderFns } from "./AddCustomChecklistItem.vue?vue&type=template&id=26bc9f1c&scoped=true&"
import script from "./AddCustomChecklistItem.vue?vue&type=script&lang=js&"
export * from "./AddCustomChecklistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc9f1c",
  null
  
)

export default component.exports